import actionTypes from '../actionTypes';

export const avatarMenu = (state = [], action) => {
    switch (action.type) {
        case actionTypes.AVATAR_MENU_SUCCESS:
            return action.menu;
        default:
            return state;
    }
};

export const accountAvatars = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.AVATARS_SUCCESS:
            return {...state, ...action.avatars};
        default:
            return state
    }
};

const avatarJSONsInitial = {};

export const avatarJSONs = (state = avatarJSONsInitial, action) => {
  switch (action.type) {
    case actionTypes.AVATAR_JSON_SUCCESS:
      return { ...state, [action.path]: action.json };
    default:
      return state;
  }
};